import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@mui/styles"
import {
    Typography,
    TableContainer,
    Paper,
    Table,
    TableCell,
    TableHead,
    TableRow,
    TableBody,
    IconButton,
    Tooltip,
    Modal,
    TextField,
    Button
} from "@mui/material"
import {
    Close,
    DeleteOutline,
    DownloadOutlined,
    Edit,
    Update
} from "@mui/icons-material"
import { updateFields } from "../Redux/actions/formValue.action"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"


export default function ExamListSummary({
    examData = [],
    onDownloadTimetable,
    handleDeleteExam,
    handleEditExamination
}) {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [isEditExamName, setIsEditExamName] = React.useState(false)
    const [editExamId, setEditExamId] = React.useState("")
    const [editExamName, setEditExamName] = React.useState("")

    const formState = useSelector((state) => state.form)


    return (
        <div className="col-md-12">
            {
                examData.length > 0 && (
                    <div className="col-md-12">
                        {
                            examData.map((exam, index) => {
                                let {
                                    exam_name,
                                    class_ref,
                                    created_at,
                                    id,
                                    school_ref,
                                    timetables,
                                    updated_at
                                } = exam
                                return (
                                    <div className="col-md-12" key={index} style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "12px"
                                    }}>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "row"
                                        }}>
                                            <Typography classes={{
                                                root: classes.examName
                                            }}>{exam_name}</Typography>
                                            <Tooltip title={"Edit Examination Name"} arrow placement="bottom" >
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        setIsEditExamName(true)
                                                        setEditExamId(id)
                                                        setEditExamName(exam_name)
                                                    }}
                                                >
                                                    <Edit />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={"Delete Timetable"} arrow placement="bottom" >
                                                <IconButton
                                                    size="small"
                                                    onClick={()=> {
                                                        handleDeleteExam(id)
                                                    }}
                                                >
                                                    <DeleteOutline color="warning" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={"Download timetable"} arrow placement="bottom" >
                                                <IconButton
                                                    onClick={() => {
                                                        let tTable = timetables && timetables.length > 0 && timetables[0].exam_timetable
                                                        onDownloadTimetable(tTable, class_ref, school_ref, exam_name, id)
                                                    }}
                                                    disabled={!timetables || timetables.length === 0}
                                                    size="small"
                                                >
                                                    <DownloadOutlined />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        {
                                            timetables && Array.isArray(timetables) && timetables.length > 0 ? (
                                                <TableContainer component={Paper}>
                                                    <Table>
                                                        <TableHead classes={{
                                                            root: classes.tableHeader
                                                        }}>
                                                            <TableRow>
                                                                <TableCell>SL_NO</TableCell>
                                                                <TableCell>Subject</TableCell>
                                                                <TableCell>Date</TableCell>
                                                                <TableCell>Start Time</TableCell>
                                                                <TableCell>End Time</TableCell>
                                                                <TableCell>Actions</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                timetables[0] && timetables[0].exam_timetable.map((row, i) => {
                                                                    return (
                                                                        <TableRow key={row.subject + i}>
                                                                            <TableCell>{i + 1}</TableCell>
                                                                            <TableCell>{row.subject}</TableCell>
                                                                            <TableCell>{row.date}</TableCell>
                                                                            <TableCell>{row.start}</TableCell>
                                                                            <TableCell>{row.end}</TableCell>
                                                                            <TableCell>
                                                                                <Tooltip title={"Delete"} arrow placement="bottom">
                                                                                    <IconButton
                                                                                        size="small"
                                                                                    >
                                                                                        <DeleteOutline
                                                                                            color="warning"
                                                                                        />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            ) : (
                                                <div style={{
                                                    height: "30px",
                                                    border: "1px solid gray",
                                                    borderRadius: "4px",
                                                    flex: 1,
                                                    padding: "4px"
                                                }}>
                                                    <Typography>Examination timetable data not setup yet!</Typography>
                                                </div>
                                            )
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }
            <Modal
                open={isEditExamName}
                onClose={() => {
                    setIsEditExamName(false)
                    setEditExamId("")
                    setEditExamName("")
                    dispatch(updateFields({ updateExamName: "" }))
                }}
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <div style={{
                    width: "300px",
                    height: "300px",
                    border: "1px solid white",
                    borderRadius: "12px",
                    backgroundColor: "pink"
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "4px",
                        backgroundColor: "#FFFF",
                        borderTopRightRadius: "12px",
                        borderTopLeftRadius: "12px"
                    }}>
                        <Typography>{editExamName}</Typography>
                        <Tooltip title={"Close"} arrow placement="bottom">
                            <IconButton onClick={() => {
                                setIsEditExamName(false)
                                setEditExamId("")
                                setEditExamName("")
                                dispatch(updateFields({ updateExamName: "" }))
                            }}>
                                <Close />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div style={{
                        flexGrow: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "70%"
                    }}>
                        <TextField
                            placeholder="Enter Examination New Name"
                            label={"Enter Examination New Name"}
                            variant="outlined"
                            fullWidth
                            value={_.get(formState, "state.updateExamName", "")}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ updateExamName: val.toUpperCase() }))
                            }}
                        />
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "4px",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "4px"
                    }}>
                        <Button
                            size="small"
                            variant="text"
                            onClick={() => {
                                setIsEditExamName(false)
                                setEditExamId("")
                                setEditExamName("")
                                dispatch(updateFields({ updateExamName: "" }))
                            }}
                        >
                            cancel
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            startIcon={<Update />}
                            onClick={()=> {
                                const exam_name = _.get(formState, "state.updateExamName", "")
                                if(!exam_name || !editExamId) return
                                handleEditExamination(editExamId,exam_name)
                                setIsEditExamName(false)
                                setEditExamId("")
                                setEditExamName("")
                            }}
                        >
                            Update
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
ExamListSummary.propTypes = {
    examData: PropTypes.array,
    onDownloadTimetable: PropTypes.func,
    handleDeleteExam: PropTypes.func,
    handleEditExamination: PropTypes.func
}

const useStyles = makeStyles({
    examName: {
        fontFamily: "Lato",
        fontSize: "14px",
        fontWeight: "bold",
        lineHeight: "10px",
        fontStyle: "normal",
        borderBottom: "2px solid red",
        padding: "10px",
        textTransform: "uppercase",
        textAlign: "center",
        flex: 1
    },
    tableHeader: {
        padding: 0,
        backgroundColor: "pink"
    }
})